<template>
	<UnidadeLayout>
		<nav class="navbar nav-bar-unidade">
			<div class="container-fluid">
				<a class="navbar-brand" href="#">
					{{ vue_app_name }}
				</a>
				<ConsultaSwitch />
			</div>
		</nav>
		<div class="p-5">
			<div class="container header text-center">
				<h2>Minhas unidades:</h2>
				<hr />
			</div>
			<div class="container mb-3 d-flex justify-content-center">
				<input
					v-model="filtroUnidade"
					type="text"
					class="form-control w-50"
					placeholder="Pesquisar unidade..."
				/>
			</div>
			<div class="container card-unidades d-flex flex-wrap justify-content-center">
				<CardUnidade
					v-for="unidade in unidadesFiltradas"
					:key="unidade.id"
					:unidade="unidade" />
			</div>
		</div>
	</UnidadeLayout>
</template>
<script>
	import UnidadeLayout from "@/components/layouts/UnidadeLayout.vue";
	import CardUnidade from "@/components/ui/App/CardUnidade.vue";
	import ConsultaSwitch from "@/components/ui/App/ConsultaSwitch.vue";

	import { ref, onMounted, computed } from "vue";
	import { useStore } from "vuex";
	import { useToast } from 'vue-toastification';

	export default {
		name: "UnidadesPage",
		components: {
			UnidadeLayout,
			CardUnidade,
			ConsultaSwitch
		},
		setup() {
			const store = useStore();
			const unidades = ref([]);
			const toast = useToast();
			const vue_app_name = process.env.VUE_APP_NAME;
			const filtroUnidade = ref("");

			onMounted(async () => {
				try {
					unidades.value = store.state.unidades.unidades;
					if (unidades.value.length == 0) {
						await store.dispatch("unidades/fetchUnidades");
						unidades.value = store.state.unidades.unidades;
					}
				} catch (error) {
					console.error("Erro ao buscar unidades:", error);
					toast.error("Erro ao buscar unidades")
				}
			});

			const unidadesOrdenadas = computed(() => {
				return unidades.value.slice().sort((a, b) => {
					return (a.status === 'inativo' ? 1 : 0) - (b.status === 'inativo' ? 1 : 0);
				});
			});

			const unidadesFiltradas = computed(() => {
				if (!filtroUnidade.value) return unidadesOrdenadas.value;
				return unidadesOrdenadas.value.filter(u =>
					u.nome && u.nome.toLowerCase().includes(filtroUnidade.value.toLowerCase())
				);
			});

			return {
				unidades,
				unidadesOrdenadas,
				unidadesFiltradas,
				filtroUnidade,
				vue_app_name
			};
		},
	};
</script>
<style scoped>
.nav-bar-unidade {
    box-shadow: -3px 2px 20px 0px #999191;
    background-color: #f7f7f7 !important;
}
</style>